import { paths } from "../paths";

import MainPapakilo from '../../layouts/main/MainPapakilo';
import AboutPapakilo from '../../layouts/main/AboutPapakilo';
import MissionPapakilo from '../../layouts/main/MissionPapakilo';
// import StoryPapakilo from '../../layouts/main/StoryPapakilo';
import CareerPapakilo from '../../layouts/main/CareerPapakilo';
import LocationPapakilo from '../../layouts/main/LocationPapakilo';
import ContactPapakilo from '../../layouts/main/ContactPapakilo';
import ServicePapakilo from '../../layouts/main/ServicePapakilo';
import BranchPapakilo from '../../layouts/main/BranchPapakilo';
import ProductPapakilo from '../../layouts/main/ProductPapakilo';

// Sub Branch
import JakartaBranch from "../../layouts/main/sections/Branch/Jakarta/JakartaBranch";
import ArizonaBranch from "../../layouts/main/sections/Branch/Medan/Arizona/ArizonaBranch";
import BostonBranch from "../../layouts/main/sections/Branch/Medan/Boston/BostonBranch";

export const HairstudioRoutes = [
 {
  path: paths.root,
  element: <MainPapakilo />
 },
 {
  path: paths.aboutHairstudio,
  element: <AboutPapakilo />
 },
 {
  path: paths.missionHairstudio,
  element: <MissionPapakilo />
 },
 // {
 //  path: paths.storyHairstudio,
 //  element: <StoryPapakilo />
 // },
 {
  path: paths.careers,
  element: <CareerPapakilo />
 },
 {
  path: paths.location,
  element: <LocationPapakilo />
 },
 {
  path: paths.contactus,
  element: <ContactPapakilo />
 },
 {
  path: paths.services,
  element: <ServicePapakilo />
 },
 {
  path: paths.products,
  element: <ProductPapakilo />
 },
 {
  path: paths.branch,
  element: <BranchPapakilo />,
 },
 {
  path: paths.branchJakarta,
  element: <JakartaBranch />
 },
 {
  path: paths.branchArizona,
  element: <ArizonaBranch />
 },
 {
  path: paths.branchBoston,
  element: <BostonBranch />
 },
]